(ns nosco.ui.buttons
  (:require
   ["react" :as React]
   [hx.react :refer [defnc]]
   [nosco.react]
   [nosco.icons :as icons]
   [nosco.icons2 :as icons2]))

;; The text content of a button is always passed by the label prop -- this is so
;; we can ensure that buttons always have an accessible label.

(defnc ^:private Button [{:keys [label loading icon children] :as props} ref]
  [(if (:href props) :a :button)
   (-> {:ref ref
        :class ["nosco-btn"]
        :disabled loading
        :aria-label label}
       (nosco.react/merge-props (dissoc props :label :loading)))
   (when loading
     [icons/LoadingIcon
      {:style {:opacity (if loading 1 0)}
       :class "nosco-btn__loading-icon"}])
   [:span {:class "nosco-btn__label"
           :style {:opacity (if loading 0 1)}}
    label
    (when icon icon)]
   children])

(nosco.react/forward-ref! Button)

(defnc PrimaryButton [props ref]
  [Button
   (-> {:ref ref
        :class ["nosco-btn--primary"]}
       (nosco.react/merge-props props))])

(nosco.react/forward-ref! PrimaryButton)

(defnc TextButton [props ref]
  [Button
   (-> {:ref ref
        :class ["nosco-btn--text"]}
       (nosco.react/merge-props props))])

(nosco.react/forward-ref! TextButton)









(defnc ButtonGroup
  "Props:
  - :inline - when true, renders the container as an inline element
  - :justify - :end or :between, positions the buttons as with justify-content"
  [{:keys [inline justify children]}]
  [:div
   {:class ["nosco-btn-group"
            (if inline "d-inline-flex" "d-flex")
            (case justify
              :end "justify-content-end"
              :start "justify-content-start"
              :between "justify-content-between"
              nil nil)]}
   children])

(defnc ^{:deprecated "Use nosco.ui.buttons2/Button, which carries the current variants, tones and sizes."}
  ActionButton
  "Props:
  - :icon - The name of an icon or a React element"
  [{:keys [label children disabled icon selected activated icon-only variant] :as props} ref]
  (assert #{:secondary :tertiary nil} variant)
  (let [href (:href props)]
    [(if href :a :button)
     (-> {:ref ref
          :class ["nosco-btn nosco-action-btn"
                  (when (= :secondary variant) "nosco-action-btn--secondary")
                  (when (= :tertiary variant) "nosco-action-btn--tertiary")
                  (when selected "nosco-action-btn--selected")
                  (when activated "nosco-action-btn--activated")
                  (when icon-only "nosco-action-btn--icon-only")]
          :aria-label label}
         (cond->
          (and (not disabled) href)
           (assoc :href href))
         (nosco.react/merge-props
          (dissoc props :href :label :icon :selected :activated :icon-only :variant)))
     (when icon
       (if (React/isValidElement icon)
         icon
         [icons2/Icon
          {:class ["nosco-action-btn__icon"]
           :icon icon
           :aria-hidden true}]))
     [:<>
      (when-not icon-only
        label)
      children]]))

(nosco.react/forward-ref! ActionButton)

(defnc ^{:deprecated "Groups the deprecated ActionButton. Lay nosco.ui.buttons2/Button out in a flex container instead."}
  ActionButtonGroup
  "Props:
  - :inline - when true, renders the container as an inline element"
  [{:keys [inline class children]}]
  [:div {:class [(when inline "d-inline-block")]}
   [:div {:class (nosco.react/merge-class ["nosco-action-btn-group"] class)}
    children]])

(defnc ^{:deprecated "Groups the deprecated ActionButton. Lay nosco.ui.buttons2/Button out in a flex container instead."}
  SecondaryActionButtonGroup
  "Props:
  - :inline - when true, renders the container as an inline element"
  [{:keys [inline children ]}]
  [:div {:class [(when inline "d-inline-block")]}
   [:div {:class ["nosco-action-btn-group--secondary"]}
    children]])
